import React from "react";

import PropTypes from "prop-types";

const AdaptiveIcon = ({ sm, lg }) => (
  <>
    <div className="d-xs-block d-md-none">{sm}</div>
    <div className="d-none d-md-block">{lg}</div>
  </>
);

AdaptiveIcon.propTypes = {
  lg: PropTypes.node.isRequired,
  sm: PropTypes.node.isRequired,
};

export default AdaptiveIcon;
